import * as React from 'react';
import {observer} from 'mobx-react'

import SurveyStore from '../../../store/models/SurveyModel';

export default observer(function(){
  const isSurveyLoaded = SurveyStore.status === 'survey is loaded';
  const backgroundImageUrl = isSurveyLoaded 
    ? (SurveyStore.survey.answerSchema?.backgroundImageUrl || 'https://static.retail.autofact.cl/surveys/banner-big.jpg')
    : '';
  
  const headerStyle = backgroundImageUrl ? {
    backgroundImage: `url(${backgroundImageUrl})`
  } : {};

  return (
      <div className="cmp-header" style={headerStyle}>
        <div className="container">
          <div className="logo-container">
            <img data-src="https://static.retail.autofact.cl/img/logo-blanco.svg" className="img-fluid lozad"
                 alt="Logo Autofact" width={440}/>
          </div>
          <h1 className="main-title font-size-38 font-source-sans font-bold">{SurveyStore.title}</h1>
        </div>
      </div>
  )
});